import * as React from 'react';
const SvgChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.21 11.303 11.05 8.15c-.19-.2-.51-.2-.7 0l-.7.7c-.2.191-.2.501 0 .701l2.46 2.453-2.46 2.452c-.19.19-.19.51 0 .7l.7.701a.5.5 0 0 0 .7 0l3.16-3.153a.985.985 0 0 0 0-1.4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronRight;
